/* eslint-disable @typescript-eslint/no-explicit-any */
import { getIdSports } from '../../../common/data/sports';
import { getModel } from '../../../services/api2.service';

/**
 * Get format
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getFormatsBySport = async (query): Promise<any> => {
    const sportId = getIdSports(query.sport)

    let filter = '';
    if (query) {
        filter = `?sportId=${sportId ? sportId : ''}`;
    }
    const urlModel = `formats${filter}`;
    const data = await getModel(urlModel);
    return data.data;
};
